export default {"src":"/_next/static/media/carWithPlusIconPlayground5LightBg_104.9369ccb5.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};